import { FormInstance } from 'antd';
import { EnumReportTypes } from '../types/reports';
import { formatAmount } from './formatAmount';

type FieldValues = {
  uip?: number;
  vaFundingFee?: number;
  closingCosts?: number;
  cashOut?: number;
  addUip?: boolean;
  addVaFundingFee?: boolean;
  addClosingCosts?: boolean;
  addCashOut?: boolean;
  uipActive?: boolean;
  vaFundingFeeActive?: boolean;
  closingCostsActive?: boolean;
  cashOutActive?: boolean;
  reportType?: EnumReportTypes;
}

export const calculateLoanAmountWithUip = (
  form: FormInstance,
  loanIndex: string | number,
  {
    uip,
    vaFundingFee,
    closingCosts,
    cashOut,
    addUip,
    addVaFundingFee,
    addClosingCosts,
    addCashOut,
    uipActive,
    vaFundingFeeActive,
    closingCostsActive,
    cashOutActive,
    reportType
  }: FieldValues = {}
) => {
  const uipActiveValue = uipActive ?? form.getFieldValue(['tableView', 'uip', 'active']);
  const vaFundingFeeActiveValue = vaFundingFeeActive ?? form.getFieldValue(['tableView', 'vaFundingFee', 'active']);
  const closingCostsActiveValue = closingCostsActive ?? form.getFieldValue(['tableView', 'closingCosts', 'active']);
  const cashOutActiveValue = cashOutActive ?? form.getFieldValue(['tableView', 'cashOut', 'active']);
  const reportTypeValue = form.getFieldValue(['loans', loanIndex, 'reportType']);

  const isRefinance = (reportType ?? reportTypeValue) === EnumReportTypes.refinance;

  const addUipValue = addUip ?? form.getFieldValue(['loans', loanIndex, 'addUip']);
  const addVaFundingFeeValue = addVaFundingFee ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addVaFundingFee']);
  const addClosingCostsValue = addClosingCosts ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addClosingCosts']);
  const addCashOutValue = addCashOut ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addCashOut']);
  const loanAmount = parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmount', 'value'])) || 0;
  const uipValue = uip ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'uip', 'value'])) || 0);
  const vaFundingFeeValue =
    vaFundingFee ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'vaFundingFee'])) || 0);
  const closingCostsClearedAt = form.getFieldValue(['loans', loanIndex, 'externalLoan', 'closingCostsClearedAt'])
  const closingCostsValue = closingCostsClearedAt ? 0 :
    closingCosts ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'closingCosts', 'value'])) || 0);
  const cashOutValue = cashOut ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'cashOut', 'value'])) || 0);

  let loanAmountWithUip = loanAmount;

  if (addUipValue && uipActiveValue) {
    loanAmountWithUip += uipValue;
  }

  if (addVaFundingFeeValue && vaFundingFeeActiveValue) {
    loanAmountWithUip += vaFundingFeeValue;
  }

  if (addClosingCostsValue && closingCostsActiveValue && isRefinance) {
    loanAmountWithUip += closingCostsValue;
  }

  if (addCashOutValue && cashOutActiveValue) {
    loanAmountWithUip += cashOutValue;
  }

  return parseFloat(formatAmount(loanAmountWithUip));
}
